<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { cn } from "~/lib/utils"
import { NavDropdown, NavItem, NavLink, navMenuVariants, NavMenuVariants } from "."

const { items, variant, class: cl, ariaLabel } = defineProps<{
    items: NavItem[]
    variant?: NavMenuVariants["variant"]
    class?: HTMLAttributes["class"]
    ariaLabel?: string
}>()

const emits = defineEmits<{
    (e: "select", sectionId?: string): void
}>()
</script>

<template>
    <ul
        :aria-label="ariaLabel"
        :class="cn(navMenuVariants({ variant }), cl)"
    >
        <li
            v-for="item of items"
            :key="item.name"
            :class="cn('flex items-center', item.class)"
        >
            <Component
                :is="item.items?.length ? NavDropdown : NavLink"
                :item="item"
                :variant="variant"
                :class="item.items?.length ? 'text-nav-bar-items' : undefined"
                @select="(id: string | undefined) => emits('select', id)"
            />
        </li>
    </ul>
</template>